<template>
  <section v-if="data.items?.length" class="usp" :class="{'isLoyaltyPage': isLoyaltyLandingPage}">
    <div class="container">
      <div v-for="item in data.items" class="usp__Item">
        <Flare :srcset="item.image" size="both" width="48" height="48" crop="fill" :alt="item.description" />
        {{ item.description }}
      </div>
    </div>
  </section>
</template>

<script setup>
  const { page } = usePage();

  defineProps({
    data: {},
  });

  const isLoyaltyLandingPage = computed(() => page.value.meta.type.includes('LoyaltyPage'));
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_usp.scss');
</style>